define([
    "./occurrenceCauseModule",
    "./occurrenceCauseRouter",
    "./search/OccurrenceCauseSearchController",
    "./edition/OccurrenceCauseEditionController",
    "./occurrenceCauseService",
    "./causeIcons/OccurrenceCauseIcon"
], function () {
});